import { scales, variants } from "./types";

export const scaleVariants = {
  [scales.MD]: {
    height: "48px",
    padding: "0 24px",
  },
  [scales.SM]: {
    height: "32px",
    padding: "0 16px",
  },
  [scales.XS]: {
    height: "28px",
    fontSize: "12px",
    padding: "0 12px",
  },
};

export const styleVariants = {
  [variants.PRIMARY]: {
    background: "linear-gradient(45deg, #006622, #00b33c)",
    color: "white",
  },
  [variants.SECONDARY]: {
    background: "none",
    backgroundColor: "transparent",
    border: "2px solid",
    borderColor: "primary",
    boxShadow: "none",
    color: "primary",
    ":disabled": {
      backgroundColor: "transparent",
    },
  },
  [variants.TERTIARY]: {
    background: "none",
    backgroundColor: "tertiary",
    boxShadow: "none",
    color: "primary",
  },
  [variants.SUBTLE]: {
    background: "none",
    backgroundColor: "textSubtle",
    color: "backgroundAlt",
  },
  [variants.DANGER]: {
    background: "none",
    backgroundColor: "failure",
    color: "white",
  },
  [variants.SUCCESS]: {
    background: "none",
    backgroundColor: "success",
    color: "white",
  },
  [variants.TEXT]: {
    background: "none",
    backgroundColor: "transparent",
    color: "primary",
    boxShadow: "none",
  },
  [variants.LIGHT]: {
    background: "none",
    backgroundColor: "input",
    color: "textSubtle",
    boxShadow: "none",
  },
};
